module.exports = __webpack_public_path__ + "img/luminance.af3810d0.png";